module.exports = __webpack_public_path__ + "img/icon-user-plus.ed9099ef.svg";